import React from 'react';

const createStateTool = (state) => {
  if (process.env.NODE_ENV !== 'production' && !state.devTools) {
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__?.connect();
    const unsubcrible = devTools?.subscribe((message) => {
      // Implement monitors actions.
      // For example time traveling:
      if (message.type === 'DISPATCH' && message.payload.type === 'JUMP_TO_STATE') {
        state.tools = message.type;
      }
    });
    state.unsubcrible = unsubcrible;
    state.devTools = devTools;
  }
  return state;
};

const createReducerTool = (reducer, types) => {
  const fnReducer = (state, action) => {
    if (action === undefined || action.type === undefined) {
      throw new Error('The type of action is undefined, check your dispatchers!');
    }
    const newState = reducer(state, action, types);
    if (state.devTools) {
      state.devTools.send(action.type, newState);
    }
    return newState;
  };
  return fnReducer;
};

const useStateTool = (stateContext, name) => {
  const context = React.useContext(stateContext);

  if (context === undefined) {
    throw new Error(`useState must be used within a ${name}`);
  }
  return context;
};

const useDispatchTool = (dispatchContext, name) => {
  const context = React.useContext(dispatchContext);
  if (context === undefined) {
    throw new Error(`useState must be used within a ${name}`);
  }
  return context;
};

export { createStateTool, createReducerTool, useStateTool, useDispatchTool };
